// playButtonExtraTimeAnimation.js
var PlayButtonExtraTimeAnimation = pc.createScript('playButtonExtraTimeAnimation');

PlayButtonExtraTimeAnimation.attributes.add('Shine', {type: 'entity'});
PlayButtonExtraTimeAnimation.attributes.add('InviteStar', {type: 'entity'});

var boingAnim;

// initialize code called once per entity
PlayButtonExtraTimeAnimation.prototype.initialize = function() {
     var self = this;

     boingAnim = this.Shine
        .tween(this.Shine.getLocalPosition())
        .to({ x: 250, y: 0, z: 0 }, 1, pc.Linear)
        .on('complete', function () {

            self.InviteStar
                .tween(self.InviteStar.getLocalScale())
                .to(new pc.Vec3(1, 1, 1), 0.2, pc.Linear)
                .yoyo(true)
                .repeat(2)
                .start();

            self.Shine.enabled = false;
            self.entity
                .tween(self.entity.getLocalScale())
                .to(new pc.Vec3(0.8, 0.8, 0.8), 0.2, pc.Linear)
                .yoyo(true)
                .repeat(2)
                .on('complete', function () {
                    self.Shine.setLocalPosition(new pc.Vec3(-250, 0, 0));
                    self.Shine.enabled = true;
                    boingAnim.start();})
                .start();
        })
        .yoyo(true)
        .start();
};


